// Hardcoded content for The Uncanny House
export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_the-house-list/artifacts/c18cx83x_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2007_51_56%20AM.png";

export const MENU_FEATURED_IMAGE =
  "https://images.unsplash.com/photo-1705952285570-113e76f63fb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbW9vZHklMjBjb2ZmZWUlMjBlc3ByZXNzbyUyMGx1eHVyeXxlbnwwfHx8fDE3ODEwNTQ3MjB8MA&ixlib=rb-4.1.0&q=85";

export const MEMBERSHIP_IMAGE =
  "https://customer-assets.emergentagent.com/job_the-house-list/artifacts/bmpsojhq_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2008_54_50%20AM.png";

export const PUMABILT_IMAGE =
  "https://customer-assets.emergentagent.com/job_the-house-list/artifacts/aeni3jfi_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2007_20_05%20AM.png";

export const BOTANICAL_IMAGE =
  "https://images.unsplash.com/photo-1681572028201-0e13e0810714?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxkYXJrJTIwYm90YW5pY2FsJTIwb2xpdmUlMjBsZWF2ZXN8ZW58MHx8fHwxNzgxMDU0NzIwfDA&ixlib=rb-4.1.0&q=85";

export const FAQ_IMAGE =
  "https://customer-assets.emergentagent.com/job_the-house-list/artifacts/0qt550my_ChatGPT%20Image%20Jul%207%2C%202026%2C%2004_16_28%20PM.png";

export const MENU = [
  {
    key: "cold-brew",
    title: "Cold Brew Collection",
    blurb: "Slow steeped 18 hours. Served over hand-cut obsidian ice.",
    items: [
      { name: "Black Obsidian", desc: "Single origin Ethiopian, neat. Bittersweet, dark plum.", price: "7" },
      { name: "Brass Velvet", desc: "Cold brew, brown butter syrup, oat cream float.", price: "8" },
      { name: "Smoke & Honey", desc: "Mezcal-washed cold brew, raw honey, charred orange peel.", price: "9" },
      { name: "The Curator", desc: "Nitro cold brew, vanilla bean, hand-cut maraschino.", price: "9" },
    ],
  },
  {
    key: "lattes",
    title: "Specialty Lattes",
    blurb: "Espresso pulled to order. Every cup, crafted with intention.",
    items: [
      { name: "Espresso Brown Sugar", desc: "Double shot, burnt sugar, brown butter foam.", price: "7" },
      { name: "Olive Oil Latte", desc: "Cold press olive oil, sea salt, oat milk.", price: "8" },
      { name: "Obsidian Mocha", desc: "Single origin chocolate, espresso, hand whisked.", price: "8" },
    ],
  },
  {
    key: "matcha",
    title: "Matcha",
    blurb: "Ceremonial matcha, stone milled. Whisked by hand.",
    items: [
      { name: "Lavender Honey Matcha", desc: "Ceremonial matcha, dusty lavender, raw honey.", price: "8" },
      { name: "Ceremonial Matcha", desc: "Stone-milled first harvest, gently whisked.", price: "7" },
      { name: "Iced Matcha Cream", desc: "Cold ceremonial matcha over house cream.", price: "8" },
    ],
  },
  {
    key: "refreshers",
    title: "Refreshers",
    blurb: "Bright, low-sugar, botanical.",
    items: [
      { name: "Olive Leaf Tonic", desc: "Olive leaf, cucumber, yuzu, soda.", price: "6" },
      { name: "Rose Lychee Spritz", desc: "Rose, lychee, white grape, sparkling.", price: "7" },
      { name: "Bone Citrus", desc: "Bergamot, blood orange, salted honey.", price: "6" },
    ],
  },
  {
    key: "vault",
    title: "The Dessert Parlor",
    blurb: "Small batches, thoughtfully prepared. Limited by design.",
    items: [
      { name: "Burnt Basque", desc: "Brown butter Basque cheesecake, sea salt.", price: "9" },
      { name: "Olive Oil Citrus", desc: "Olive oil cake, candied bergamot, mascarpone.", price: "9" },
      { name: "Espresso Tres Leches", desc: "Espresso soaked, cardamom cream, brass dust.", price: "10" },
      { name: "Lavender Honey Pavlova", desc: "Lavender meringue, raw honey, fig.", price: "10" },
    ],
  },
];

export const WEEKLY_DROPS = [
  {
    code: "DROP 042",
    name: "Smoked Fig & Brass",
    window: "Friday — Sunday",
    desc: "Single origin espresso, smoked black fig, brown butter cream. 60 cups only.",
    status: "Available Friday 7am",
  },
  {
    code: "DROP 041",
    name: "Olive & Obsidian",
    window: "Sold Out",
    desc: "Olive leaf tonic with charred orange, salted honey. Returns next month.",
    status: "Archived",
  },
  {
    code: "DROP 040",
    name: "Lavender Tres Leches",
    window: "Sold Out",
    desc: "Dusty lavender milk cake, brass-dusted shoulder. The most requested drop of the year.",
    status: "Archived",
  },
];

export const EVENTS = [
  {
    id: "popup-river-park",
    title: "House Pop-Up — River Park Shopping Center",
    date: "September 25 — 27, 2026",
    location: "Fresno, CA",
    blurb: "Three nights, after sundown. Limited menu. Stewards first.",
  },
  {
    id: "art-hop-fulton",
    title: "Art Hop — Fulton Mall",
    date: "Thursday, October 1, 2026",
    location: "Fresno, CA",
    blurb: "A six-course coffee & cake pairing hidden amid downtown rush hour.",
  },
  {
    id: "river-park-spooktacular",
    title: "River Park Farmers Market — Spooktacular",
    date: "Tuesday, October 13, 2026",
    location: "Fresno, CA",
    blurb: "One night in the heart of River Park. Forty seats. Stewards first.",
  },
];

export const MEMBERSHIP_PERKS = [
  { title: "Permanent Steward Number", desc: "Your number is yours for life. Engraved on a brass card." },
  { title: "Early Access", desc: "48 hours before public release on every limited drop." },
  { title: "Secret Menu", desc: "Off-menu drinks and desserts available only to House Stewards." },
  { title: "Pop-Up Invitations", desc: "Private invitations to residencies, dinners, and city pop-ups." },
  {
    title: "Obsession Alerts — Coming Soon",
    desc: "Be the first to know when an item from your Obsession List returns, when a new drop matches your interests, when Reserve-only releases become available, and when seasonal offerings are released.",
  },
];
